import { isMobileDevice } from 'Utilities/devices';
import { User } from 'Utilities/user/@types';

export const optimizelyAttributes = ({ userId, ...attributes }: { userId?: User['id'] | null }) => ({
  isMobile: isMobileDevice({}),
  userAgent: globalThis?.navigator?.userAgent || null,
  userId: userId?.toString() || null,
  ...attributes,
});
